import React from "react";
import {
    ClipboardList,
    Target,
    Palette,
    Layout,
    Camera,
    Sparkles,
    Check,
} from "lucide-react";
import { FORGE } from "@/constants/testIds";

const ICON_MAP = {
    clipboard: ClipboardList,
    target: Target,
    palette: Palette,
    layout: Layout,
    camera: Camera,
    sparkles: Sparkles,
};

/**
 * PipelineNodes — horizontal 6-agent tracker across the top of the app.
 * status: "idle" | "active" | "done"
 */
export default function PipelineNodes({ agents, statuses, activeIndex }) {
    return (
        <div className="w-full flex items-start gap-1">
            {agents.map((agent, idx) => {
                const status = statuses[agent.id] || "idle";
                const Icon = ICON_MAP[agent.icon] || Sparkles;
                const isActive = status === "active";
                const isDone = status === "done";

                return (
                    <React.Fragment key={agent.id}>
                        <div
                            data-testid={FORGE.pipelineNode(agent.id)}
                            data-status={status}
                            className="flex flex-col items-center gap-2 min-w-[110px] flex-shrink-0"
                        >
                            <div
                                className={`relative w-12 h-12 rounded-full flex items-center justify-center border transition-colors duration-300 ${
                                    isDone
                                        ? "bg-[color:var(--profecia-gold)] border-[color:var(--profecia-gold)] text-white"
                                        : isActive
                                          ? "bg-white border-[color:var(--profecia-gold)] text-[color:var(--profecia-gold)] agent-pulse"
                                          : "bg-white border-[color:var(--border-subtle)] text-[color:var(--text-muted)]"
                                }`}
                            >
                                {isDone ? (
                                    <Check
                                        size={20}
                                        strokeWidth={2.4}
                                    />
                                ) : (
                                    <Icon size={20} strokeWidth={1.8} />
                                )}
                                <span
                                    className={`absolute -top-2 -right-1 text-[10px] font-mono font-medium px-1.5 py-0.5 rounded-sm ${
                                        isDone || isActive
                                            ? "bg-[color:var(--profecia-gold)] text-white"
                                            : "bg-[color:var(--surface-hover)] text-[color:var(--text-muted)]"
                                    }`}
                                >
                                    0{idx + 1}
                                </span>
                            </div>
                            <div className="text-center px-1">
                                <div
                                    className={`text-xs font-medium leading-tight ${
                                        isActive || isDone
                                            ? "text-[color:var(--text-main)]"
                                            : "text-[color:var(--text-muted)]"
                                    }`}
                                >
                                    {agent.name}
                                </div>
                                <div
                                    className={`text-[10px] mt-0.5 uppercase tracking-widest font-mono ${
                                        isActive
                                            ? "text-[color:var(--profecia-gold)]"
                                            : "text-[color:var(--text-muted)] opacity-60"
                                    }`}
                                >
                                    {isActive
                                        ? "processing"
                                        : isDone
                                          ? "complete"
                                          : "idle"}
                                </div>
                            </div>
                        </div>
                        {idx < agents.length - 1 && (
                            <div
                                className={`pipeline-connector ${isDone ? "done" : ""}`}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
